<template>
    <div style="padding: 10px;background: #f8f8f9">
        <Card :padding="0" shadow v-if="isShow">
            <CellGroup>
                <Cell title="账号">
                  <div slot="extra">{{sta.userId}}</div>
                </Cell>
                <Cell title="手机" :extra="sta.mobileNum===''?'':sta.mobileNum.replace(sta.mobileNum.substring(3,7),'****')">
                </Cell>
                <Cell title="微信">
                    <div slot="extra">
                       <!--  <div v-if="sta.wxunionid==='' || sta.wxopenid===''"> -->
                        <div v-if="sta.wxunionid===''">
                            <span style="padding-right:10px;color:#323233;font-weight: 400;" > 未关联</span>
                            <Button size="small" type="primary" @click="bindWechat">关联微信</Button>
                        </div>
                        <div v-else style="padding-right:10px;color:#323233;font-weight: 400;" ><Icon type="md-checkmark-circle" color='#2878FF' size="16" /> 已关联</div>
                    </div>
                </Cell>
                <Cell v-if="sta.maxopendocnum < 999999" title="文件访问上限次数">
                  <div slot="extra"><span>{{sta.opendocnum}}</span> / <span>{{sta.maxopendocnum}}</span> <Button size="small" :style="{borderRadius:'2px',boxShadow:'none',color:'green'}" type="text" ghost @click="gostore">升级</Button></div>
                </Cell>
                <Cell v-else title="文件访问上限次数">
                  <div slot="extra"><span style="padding-right:10px;color:#2878FF;">无限制</span></div>
                </Cell>
            </CellGroup>
        </Card>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import eventBus from '../common/event_bus.js'
import store from '../../store/'
export default {
    name: 'UserInfo',
    data() {
        return {
            acc: '',
            tel: '',
            isShow: true,
        }
    },
    methods: {
        gostore(){
             this.$router.push({ name: 'userstore', params: { tabindex: 'name1' } })
        },
        loadUserinfo() {

        },
        bindWechat(){
           eventBus.$emit("user-bind-wechat")
        }

    },
    created() {},
    mounted: function() {
        //this.loadUserinfo()
    },
    computed: {
        ...mapGetters(['sta'])
    },


}
</script>
<style>
</style>